export default __webpack_public_path__ + "static/media/foreign-language-icon.678a36ad.webp";